document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('template-policy-native')) return;

  const title = document.querySelector('.shopify-policy__title h1');
  if (title && !title.dataset.policyEnhanced) {
    const words = title.textContent.trim().split(/\s+/).filter(Boolean);

    if (words.length > 1) {
      const primary = words.slice(0, -1).join(' ');
      const secondary = words[words.length - 1];

      title.innerHTML = `
        <span class="shopify-policy__title-line">${primary}</span>
        <span class="shopify-policy__title-line shopify-policy__title-line--offset">${secondary}</span>
      `;
    } else if (words.length === 1) {
      title.innerHTML = `<span class="shopify-policy__title-line">${words[0]}</span>`;
    }

    title.dataset.policyEnhanced = 'true';
  }

  const paragraphs = Array.from(document.querySelectorAll('.shopify-policy__body .rte > div > p'));
  if (!paragraphs.length) return;

  const firstParagraph = paragraphs[0];
  const firstText = firstParagraph.textContent.trim();

  if (/^last updated:/i.test(firstText)) {
    firstParagraph.classList.add('policy-native__meta');
  }

  const leadParagraph = paragraphs.find((paragraph) => !paragraph.classList.contains('policy-native__meta') && paragraph.textContent.trim().length > 0);
  if (leadParagraph) {
    leadParagraph.classList.add('policy-native__lead');
  }
});
